module.exports = __webpack_public_path__ + "img/qr-booker-icon.1dc44f08.png";